import { FC } from 'react';

import { TooltipProps } from 'recharts';
import { EStatisticType } from 'views/Statistics/StatisticsView.types';

import { formatValue } from '../utils';

interface PieTooltipProps extends TooltipProps<number, string> {
  metricType: EStatisticType;
}

export const PieTooltip: FC<PieTooltipProps> = ({
  active,
  payload,
  metricType
}) => {
  if (!active || !payload || payload.length === 0) return null;

  const data = payload[0];
  if (!data) return null;

  return (
    <div
      className="rounded bg-card p-2 border border-border text-sm bg-base-popover"
    >
      <div className="flex items-center gap-2">
        <div
          className="h-2.5 w-2.5 rounded-full"
          style={{ backgroundColor: data.payload.fill }}
        />
        <span className="font-semibold text-base-popoverForeground">{data.name}</span>
        <span className="text-base-popoverForeground ml-auto">
          {formatValue(data.value as number, metricType)}
        </span>
      </div>
    </div>
  );
};

